import { createStyles, Theme } from '@material-ui/core';

import { container } from 'assets/jss/material-kit-pro-react.jsx';

export default (theme: Theme) =>
  createStyles({
    container,
    content: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center'
    },
    remember: {
      alignItems: 'flex-start',
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(),
      width: '90%'
    },
    forgotContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%'
    },
    confirmStateOfArizona: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(),
      '& label': {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'flex-start'
      }
    },
    forgot: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      width: '50%',
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing()
    },
    register: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing(4)
    },
    primaryText: {
      color: theme.palette.primary.main
    },
    buttonText: {
      color: theme.palette.common.white
    }
  });
